export default [
    {
        path: 'pic/list',
        name: 'content_pic_list',
        meta: { isCache: true, icon: 'md-photos', hideInMenu: false },
        component: () => import('@/views/content/pic/pic-list.vue'),
    },
    {
        path: 'pic/add',
        name: 'content_pic_add',
        meta: { isCache: true, icon: 'md-add', hideInMenu: true },
        component: () => import('@/views/content/pic/pic-add.vue'),
    },
    {
        path: 'pic/edit/:id',
        name: 'content_pic_edit',
        meta: { isCache: false, icon: 'md-create', hideInMenu: true },
        component: () => import('@/views/content/pic/pic-edit.vue'),
    },
    {
        path: 'pic/detail/:id',
        name: 'content_pic_detail',
        meta: { isCache: false, icon: 'md-list-box', hideInMenu: true },
        component: () => import('@/views/content/pic/pic-detail.vue'),
    },
];
